// packages import
import { Maybe } from 'graphql/jsutils/Maybe'
import { FC, useContext, useState } from 'react'

// component imports

// others
import { Autocomplete, createFilterOptions, TextField } from '@mui/material'
import { LawType } from '../../../../generated'
import { CaseContext } from '../../../context'
import { menuHeight } from '../../../theme/styleConstants'

interface LawTypeFilterProps {
  lawTypeId: any
  setReportFilters: any
}

const LawTypeFilter: FC<LawTypeFilterProps> = ({ lawTypeId, setReportFilters }) => {
  const { allLawTypes } = useContext(CaseContext)
  const [lawType, setLawType] = useState<Maybe<LawType>>()

  const handleMatterChange = (value: Maybe<LawType>) => {
    setReportFilters((prev: any) => ({ ...prev, lawTypeId: value?.id }))
  }

  return (
    <Autocomplete
      fullWidth
      options={allLawTypes || []}
      onChange={(event, newValue) => {
        setLawType(newValue)
        return handleMatterChange(newValue)
      }}
      ListboxProps={menuHeight}
      getOptionLabel={value => value?.name || ''}
      filterOptions={createFilterOptions({ ignoreCase: true })}
      isOptionEqualToValue={(option, value) => {
        return option?.id === value?.id
      }}
      value={lawType ?? undefined}
      sx={{ width: '200px' }}
      renderInput={params => <TextField {...params} label="Law Type" />}
    />
  )
}

export default LawTypeFilter
